/**
 * Bandeau « Les menus ont été simplifiés » (module `navigation_v3`, ADR 0069) :
 * affiché une fois par personne et par navigateur. Simple confort d'affichage,
 * gardé dans le `localStorage` ; un navigateur qui le refuse le réaffiche.
 */
const KEY_PREFIX = "mada.navV3NoticeSeen.";

export function navV3NoticeSeen(userId: string): boolean {
  try {
    return localStorage.getItem(KEY_PREFIX + userId) === "1";
  } catch {
    return false;
  }
}

export function markNavV3NoticeSeen(userId: string): void {
  try {
    localStorage.setItem(KEY_PREFIX + userId, "1");
  } catch {
    // Stockage refusé (navigation privée) : le bandeau reviendra, sans gêne.
  }
}
